// extracted by mini-css-extract-plugin
module.exports = {"wrap":"app_wrap_36wDE","dateTitle":"app_dateTitle_DbEoV","top":"app_top_2PG0g","bottom":"app_bottom_1AMUN"};